/* eslint-disable @typescript-eslint/no-unused-vars */
import type {AirdropActivityADto} from '@cohort/admin-schemas/airdropActivities';
import type {TableEmptyState} from '@cohort/merchants/components/Table';
import Table from '@cohort/merchants/components/Table';
import {formatDate} from '@cohort/shared/utils/format';
import {Disclosure} from '@headlessui/react';
import React, {Fragment} from 'react';
import {useTranslation} from 'react-i18next';

type AirdropActivitiesTableProps = {
  airdropActivities: Array<AirdropActivityADto>;
  isLoading: boolean;
  emptyState?: TableEmptyState;
};

const AirdropActivitiesTable: React.FC<AirdropActivitiesTableProps> = ({
  airdropActivities,
  isLoading,
  emptyState,
}) => {
  const {t} = useTranslation('pages', {
    keyPrefix: 'campaigns.campaign.activity.airdrop.airdropActivitiesTable',
  });
  const headers = [{label: t('tableHeaderInternalName')}, {label: t('tableHeaderDate')}];

  return (
    <Table headers={headers} isLoading={isLoading} emptyState={emptyState}>
      {airdropActivities.map(airdropActivity => (
        <Disclosure key={airdropActivity.ownershipId}>
          {({open}) => (
            <Fragment>
              <tr key={airdropActivity.ownershipId} className="py-2">
                <td className="w-1/4 py-4 pr-3 text-sm font-medium">{airdropActivity.email}</td>
                <td className="flex w-1/4 items-center gap-2 whitespace-nowrap py-4 pr-3 text-sm text-slate-500">
                  {formatDate(airdropActivity.createdAt)}
                </td>
              </tr>
            </Fragment>
          )}
        </Disclosure>
      ))}
    </Table>
  );
};

export default AirdropActivitiesTable;
